import React from "react";

const Java_Inner_Classes = () => {
  return (
    <div>
      <h1>Java Inner Classes</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Inner Classes in Java.</p>
    </div>
  );
};

export default Java_Inner_Classes;
